{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2018                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

{$I WEBLib.TMSFNCDefines.inc}

// Utility functions for FNC graphics, made for WidgetProgress stuff
unit WEBLib.TMSFNCGraphicUtils;

interface

uses
  Classes, WEBLib.TMSFNCGraphics,
  WEBLib.TMSFNCTypes, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCWidgetGraphicsTypes, WEBLib.TMSFNCUtils
  {$IFNDEF LCLLIB}
  , Types
  {$ENDIF}
  {$IFNDEF WEBLIB}
  {$IFNDEF LCLLIB}
  ,UITypes
  {$ENDIF}
  {$ENDIF}
  {$IFDEF FMXLIB}
  , WEBLib.Graphics
  {$else}
  {$IFNDEF WEBLIB}
  , Graphics
  {$ELSE}
  , WEBLib.Graphics
  {$ENDIF}
  {$ENDIF}
  ;


const
  TTMSFNCDashboardDocURL = TTMSFNCBaseDocURL + 'tmsfncdashboardpack';
  TTMSFNCDashboardTipsURL = 'https://www.tmssoftware.com/site/tmsfncdashboardpack.asp?s=faq';

  TTMSFNCDashBoardDefaultFont = 'Arial';

type
    TFNCUtilHorzRectAlign = (Center, Left, Right);
    TFNCUtilVertRectAlign = (ACenter, Top, Bottom);

  function GetRectWidth(ARect: TRectF): Single;
  function GetRectHeight(ARect: TRectF): Single;
  procedure SetRectWidth(var ARect: TRectF; AWidth: Single);
  procedure SetRectHeight(var ARect: TRectF; AHeight: Single);
  function MakeRect(x, y, width, height: Single): TRectF;
  procedure RectOffset(var ARect: TRectF; DX, DY: Single);
  function GetBottomRight(ARect: TRectF): TPointF;
  procedure SetBottomRight(var ARect: TRectF; APoint: TPointF);
  function GetTopLeft(ARect: TRectF): TPointF;
  procedure SetTopLeft(var ARect: TRectF; APoint: TPointF);
  function GetCenterPoint(ARect: TRectF): TPointF;

  // Gives an intermediate color of a gradient range for AValue;
  function GetGradientColor(AColor, AColorTo: TColor; Range: Integer; AValue: Integer): TColor;

  // These functions were made because LCL had no equivalents
  // Now we are using these in VCL, FMX and LCL
  procedure FNCUtilInflateRect(var R: TRectF; const DX, DY: Single);
  function FNCUtilOffsetRect(var R: TRectF; DX, DY: Single): Boolean;
  function FNCUtilDistance(Point1, Point2: TPointF): Single;
  function FNCUtilmidpoint(Point1, Point2: TPointF):TPointF;
  function FNCUtilPointCloserOnLine(Point1, Point2: TPointF; CloseBy: Single):TPointF;
  function FNCUtilPlaceInto(ARect: TRectF; IntoRect: TRectF;
         horzAlign: TFNCUtilHorzRectAlign; vertAlign: TFNCUtilVertRectAlign;
         ARectStrokeWidth: Single = 1): TRectF;

  // Draws a text aligned to given point by given alignment, for example,
  // this is used in multiprogress to draw the percent on the circle
  // at a given point after ValueGap. gtaCenter is used in this case
  // to draw the value properly at all angles of the circle.
  // MultiProgress also passes Thickness of the circle as StrictHeight
  // to make sure that the font is reduced till the height of text
  // is <= that height.
  procedure FNCUtilDrawTextOnPoint(AText: string; AGraphics: TTMSFNCGraphics;
   APoint: TPointF; AlignedWithPoint: TTMSFNCGraphicsTextAlign;
   StrictHeight: Single = 0; DisableVerticalCentering: Boolean = false);

  // Used to draw a filled Circle for piDot option as well as
  // for SetPoint Position and SetPoint Dots where even inner circle
  // for SetPoint is drawn with this.
  procedure FNCUtilDrawFilledCircle(
       AGraphics: TTMSFNCGraphics;
       CenterPoint: TPointF;
       ARadius: Single;
       AFill: TTMSFNCWidgetGraphicsFill
       );

  // Given two rects and text for them, combines them into
  // a bigger rect. Also centers the combined rect in the
  // Rect given in the last parameter.
  procedure FNCUtilGetTextRects(AGraphics: TTMSFNCGraphics;
        TextLine1: string; AFont1: TTMSFNCGraphicsFont;
        TextLine2: string; AFont2: TTMSFNCGraphicsFont;
        var RectText1: TRectF; var RectText2: TRectF;
        CenterCombinedInRect: TRectF);

  procedure FNCUtilReduceFontToFitText(AGraphics: TTMSFNCGraphics;
     ARect: TRectF; AText: string);

  procedure FNCUtilDrawFilledArc(AGraphics: TTMSFNCGraphics; Center, Radius: TPointF; StartAngle, SweepAngle: Single);

implementation

uses math;

function GetRectWidth(ARect: TRectF): Single;
begin
  result := ARect.Right - ARect.Left;
end;

function GetRectHeight(ARect: TRectF): Single;
begin
  result := ARect.Bottom - ARect.Top;
end;


procedure SetRectWidth(var ARect: TRectF; AWidth: Single);
begin
  ARect.Right := ARect.Left + AWidth;
end;

procedure SetRectHeight(var ARect: TRectF; AHeight: Single);
begin
  ARect.Bottom := ARect.Top + AHeight;
end;


procedure RectOffset(var ARect: TRectF; DX, DY: Single);
begin
  ARect.Left := ARect.Left + DX;
  ARect.Right := ARect.Right + DX;
  ARect.Top := ARect.Top + DY;
  ARect.Bottom := ARect.Bottom + DY;
end;

function GetBottomRight(ARect: TRectF): TPointF;
begin
  result := PointF(ARect.Right, ARect.Bottom);
end;

procedure SetBottomRight(var ARect: TRectF; APoint: TPointF);
begin
  ARect.Right := APoint.X;
  ARect.Bottom := APoint.Y;
end;

function GetTopLeft(ARect: TRectF): TPointF;
begin
  result := PointF(ARect.Left, ARect.Top);
end;

procedure SetTopLeft(var ARect: TRectF; APoint: TPointF);
begin
  ARect.Left := APoint.X;
  ARect.Top := APoint.Y;
end;

function GetCenterPoint(ARect: TRectF): TPointF;
begin
  result.X := ARect.Left + (GetRectWidth(ARect) / 2);
  result.Y := ARect.Top + (GetRectHeight(ARect) / 2);
end;


function MakeRect(x, y, width, height: Single): TRectF;
begin
  Result.Left   := x;
  Result.Top    := y;
  Result.Right := Result.Left + Width;
  Result.Bottom := Result.Top + Height;
end;


function GetGradientColor(AColor, AColorTo: TColor; Range: Integer; AValue: Integer): TColor;
var
  diffr,startr,endr: Integer;
  diffg,startg,endg: Integer;
  diffb,startb,endb: Integer;
  rstepr,rstepg,rstepb: Double;
  i: Word;
  Steps: Integer;
begin
  // each angle value is one step
  Steps := Range;

{$ifndef FMXLIB}
  AColor := ColorToRGB(AColor);
  AColorTo := ColorToRGB(AColorTo);
{$else}
  AColor := TAlphaColorRec(AColor).Color;
  AColorTo := TAlphaColorRec(AColorTo).Color;
{$endif}

  startr := (AColor and $0000FF);
  startg := (AColor and $00FF00) shr 8;
  startb := (AColor and $FF0000) shr 16;

  endr := (AColorTo and $0000FF);
  endg := (AColorTo and $00FF00) shr 8;
  endb := (AColorTo and $FF0000) shr 16;

  diffr := endr - startr;
  diffg := endg - startg;
  diffb := endb - startb;

  rstepr := diffr / steps;
  rstepg := diffg / steps;
  rstepb := diffb / steps;

  for i := 0 to steps - 1 do
  begin
    endr := startr + Round(rstepr * i);
    endg := startg + Round(rstepg * i);
    endb := startb + Round(rstepb * i);
    if i >= AValue then
      break;
  end;
  result := endr + (endg shl 8) + (endb shl 16);
end;

procedure FNCUtilDrawTextOnPoint(AText: string; AGraphics: TTMSFNCGraphics;
   APoint: TPointF; AlignedWithPoint: TTMSFNCGraphicsTextAlign;
   StrictHeight: Single = 0; DisableVerticalCentering: Boolean = false
   );
var
  r: TRectF;
  textHeight, textWidth, rectHeight: Single;
begin
  textHeight := AGraphics.CalculateTextHeight(AText);
  textWidth := AGraphics.CalculateTextWidth(AText);
  rectHeight := textHeight;
  if StrictHeight <> 0 then
  begin
    rectHeight := StrictHeight;
    // If height is strict, reduce font size till both
    // height and width comply
    while (textHeight > rectHeight)
           // or (textWidth > rectHeight) Dropped.
           // Becomes too small for 10 circles.
    do
    begin
      AGraphics.Font.Size := AGraphics.Font.Size - 1;
      textHeight := AGraphics.CalculateTextHeight(AText);
      textWidth := AGraphics.CalculateTextWidth(AText);
      if AGraphics.Font.Size <= 4 then
        break; // too small
    end;
  end;
  if AlignedWithPoint = gtaTrailing then
  begin
    // Vertical alignment is centered by default. Not disturbing this
    // so as not to break existing controls using this
    SetBottomRight(r, PointF(APoint.X, APoint.Y + rectHeight/2));
    if DisableVerticalCentering then
      r.Top := APoint.Y;
    SetTopLeft(r, PointF(r.Right - textWidth,
                          r.Bottom - rectHeight));
  end
  else
  if AlignedWithPoint = gtaLeading then
  begin
    // Vertical alignment is centered by default. Not disturbing this
    // so as not to break existing controls using this
    SetTopLeft(r, PointF(APoint.X, APoint.Y - rectHeight/2));
    if DisableVerticalCentering then
      r.Top := APoint.Y;
    SetBottomRight(r, PointF(r.Left + textWidth,
                          r.Top + rectHeight));
  end
  else
  begin
    // Vertical alignment is centered by default. Not disturbing this
    // so as not to break existing controls using this
    SetTopLeft(r, PointF(APoint.X - textWidth / 2, APoint.Y - rectHeight / 2));
    if DisableVerticalCentering then
      r.Top := APoint.Y;
    SetBottomRight(r, PointF(r.Left + textWidth,
                          r.Top + rectHeight));
  end;
  AGraphics.DrawText(r, AText, false, gtaLeading, gtaCenter, gttNone, 0, -1, -1, true);
end;


procedure FNCUtilDrawFilledCircle(
       AGraphics: TTMSFNCGraphics;
       CenterPoint: TPointF;
       ARadius: Single;
       AFill: TTMSFNCWidgetGraphicsFill
       );
var
  pth: TTMSFNCGraphicsPath;
begin
  pth := TTMSFNCGraphicsPath.Create;

  pth.AddArc(CenterPoint, PointF(ARadius, ARadius), 0, 360);

  Pth.ClosePath;
  AGraphics.Stroke.Assign(AFill);
  AGraphics.Fill.Assign(AFill);
  AGraphics.DrawPath(pth);
  pth.Free;
end;

procedure FNCUtilInflateRect(var R: TRectF; const DX, DY: Single);
begin
  R.Left := R.Left - DX;
  R.Right := R.Right + DX;
  R.Top := R.Top - DY;
  R.Bottom := R.Bottom + DY;
end;

function FNCUtilOffsetRect(var R: TRectF; DX, DY: Single): Boolean;
begin
{$ifndef WEBLIB}
  if @R <> nil then // Test to increase compatiblity with Windows
  begin
{$endif}
    R.Left := R.Left + DX;
    R.Right := R.Right + DX;
    R.Top := R.Top + DY;
    R.Bottom := R.Bottom + DY;
    Result := True;
{$ifndef WEBLIB}
  end
  else
    Result := False;
{$endif}
end;

function FNCUtilDistance(Point1, Point2: TPointF): Single;
begin
  Result := Sqrt(Sqr(Point1.X - Point2.X) + Sqr(Point1.Y - Point2.Y));
end;

function FNCUtilmidpoint(Point1, Point2: TPointF):TPointF;
begin
 result.X:=((Point2.X-Point1.X)/2)+Point1.X;
 result.Y:=((Point2.Y-Point1.Y)/2)+Point1.Y;
end;

function FNCUtilPointCloserOnLine(Point1, Point2: TPointF; CloseBy: Single):TPointF;
var
  X: Single;
begin
  X := (FNCUtilDistance(Point1, Point2) - CloseBy) / FNCUtilDistance(Point1, Point2);
  result.X:=((Point2.X-Point1.X) * X)+Point1.X;
  result.Y:=((Point2.Y-Point1.Y) * X)+Point1.Y;
end;


// Not full Delphi functionality but just the basic needed for Legend
// Assumes that ARect is smaller
function FNCUtilPlaceInto(ARect: TRectF; IntoRect: TRectF;
         horzAlign: TFNCUtilHorzRectAlign; vertAlign: TFNCUtilVertRectAlign;
         ARectStrokeWidth: Single = 1): TRectF;
var
  RectWidth, RectHeight: Single;
begin
  Result := ARect;
  RectWidth := GetRectWidth(ARect);
  RectHeight := GetRectHeight(ARect);
  // horizontal first
  if RectWidth >= GetRectWidth(IntoRect) then
    horzAlign := Left;
  case horzAlign of
    Left:
      begin
        Result.Left := IntoRect.Left;
        Result.Right := Result.Left + RectWidth;
        RectOffset(Result, ARectStrokeWidth, 0);
      end;
    Right:
      begin
        Result.Right := IntoRect.Right;
        Result.Left := Result.Right - RectWidth;
        RectOffset(Result, -ARectStrokeWidth, 0);
      end;
    Center:
      begin
        Result.Left := IntoRect.Left + (GetRectWidth(IntoRect) - GetRectWidth(ARect)) / 2;
        Result.Right := Result.Left + RectWidth;
      end;
  end;
  // vertical next
  if RectHeight >= GetRectHeight(IntoRect) then
    vertAlign := Top;
  case vertAlign of
    Top:
      begin
        Result.Top := IntoRect.Top;
        Result.Bottom := Result.Top + RectHeight;
        RectOffset(Result, 0, ARectStrokeWidth);
      end;
    Bottom:
      begin
        Result.Bottom := IntoRect.Bottom;
        Result.Top := Result.Bottom - RectHeight;
        RectOffset(Result, 0, -ARectStrokeWidth);
      end;
    ACenter:
      begin
        Result.Top := IntoRect.Top + (GetRectHeight(IntoRect) - GetRectHeight(ARect)) / 2;
        Result.Bottom := Result.Top + RectHeight;
      end;
  end;
end;

procedure FNCUtilGetTextRects(AGraphics: TTMSFNCGraphics;
        TextLine1: string; AFont1: TTMSFNCGraphicsFont;
        TextLine2: string; AFont2: TTMSFNCGraphicsFont;
        var RectText1: TRectF; var RectText2: TRectF;
        CenterCombinedInRect: TRectF);
var
  textHeight, textWidth, maxWidth, OffsetX, OffsetY: Single;
  CombinedRect, CenteredRect: TRectF;
begin
  RectText1 := RectF(0, 0, 0, 0);
  AGraphics.Font.Assign(AFont1);
  textHeight := AGraphics.CalculateTextHeight(TextLine1);
  textWidth := AGraphics.CalculateTextWidth(TextLine1);
  SetBottomRight(RectText1, PointF(textWidth, textHeight));
  RectText2 := RectF(0, 0, 0, 0);
  AGraphics.Font.Assign(AFont2);
  textHeight := AGraphics.CalculateTextHeight(TextLine2);
  textWidth := AGraphics.CalculateTextWidth(TextLine2);
  SetBottomRight(RectText2, PointF(textWidth, textHeight));
  RectOffset(RectText2, 0, GetRectHeight(RectText1));
  maxWidth := max(GetRectWidth(RectText1), GetRectWidth(RectText2));

  if GetRectWidth(RectText1) < maxWidth then
    RectText1.Right := RectText1.Left + maxWidth
  else
  if GetRectWidth(RectText2) < maxWidth then
    RectText2.Right := RectText2.Left + maxWidth;

  // Limit the width
  if (GetRectWidth(RectText1) > GetRectWidth(CenterCombinedInRect)) then
  begin
    SetRectWidth(RectText1, GetRectWidth(CenterCombinedInRect));
    SetRectWidth(RectText2, GetRectWidth(CenterCombinedInRect));
  end;

  CombinedRect := RectText1;
  SetBottomRight(CombinedRect, GetBottomRight(RectText2));

  CenteredRect := FNCUtilPlaceInto(CombinedRect,
                      CenterCombinedInRect,
                      TFNCUtilHorzRectAlign.Center,
                      TFNCUtilVertRectAlign.ACenter);
  OffsetX := CenteredRect.Left - CombinedRect.Left;
  OffsetY := CenteredRect.Top - CombinedRect.Top;
  // Readjust RectText1 and RectText2 to proper X, Y
  RectOffset(RectText1, OffsetX, OffsetY);
  RectOffset(RectText2, OffsetX, OffsetY);
end;

procedure FNCUtilReduceFontToFitText(AGraphics: TTMSFNCGraphics;
   ARect: TRectF; AText: string);
var
  TextHeight, TextWidth, RectHeight, RectWidth: Single;
begin
  textHeight := AGraphics.CalculateTextHeight(AText);
  textWidth := AGraphics.CalculateTextWidth(AText);
  rectHeight := GetRectHeight(ARect);
  rectWidth := GetRectWidth(ARect);
  while (TextHeight > RectHeight) or (TextWidth > RectWidth)
  do
  begin
    AGraphics.Font.Size := AGraphics.Font.Size - 1;
    textHeight := AGraphics.CalculateTextHeight(AText);
    textWidth := AGraphics.CalculateTextWidth(AText);
    if AGraphics.Font.Size <= 6 then
      break; // too small
  end;
end;

procedure FNCUtilDrawFilledArc(AGraphics: TTMSFNCGraphics; Center, Radius: TPointF; StartAngle, SweepAngle: Single);
var
  pth: TTMSFNCGraphicsPath;
begin
  pth := TTMSFNCGraphicsPath.Create;
  pth.AddArc(Center, Radius, StartAngle, SweepAngle);
  Pth.ClosePath;
  AGraphics.DrawPath(pth);
  pth.Free;
end;

{ KEEP FOR FUTURE:
  Made utility functions but not used as changed algorithm. Keep.
  But some changes might be needed for LCL when required. For example, Distance
  is missing in LCL so use FNCUtilDistance.
function FNCUtilRotatePointByDegrees(const APoint, ACenter : TPointF; const AAngle : single) : TPointF;
begin
  Result := (APoint - ACenter).Rotate(DegToRad(AAngle)) + ACenter;
end;

// Tested. Works OK.
function FNCUtilRotatePointByRadians(const APoint, ACenter : TPointF; const AAngle : single) : TPointF;
begin
  Result := (APoint - ACenter).Rotate(AAngle) + ACenter;
end;

function FNCUtilRotateDistance(const APoint, ACenter : TPointF; const ADistance : single) : TPointF;
var
  RotateAngle, Radius: Single;
begin
  Radius := APoint.Distance(ACenter);
  RotateAngle := ADistance /Radius;
  result := RotatePointByRadians(APoint, ACenter, RotateAngle);
end;}

end.
